module.exports = __webpack_public_path__ + "img/PXL_20230526_112205737.c8ff8427.jpg";